// helper to detect if we are on mobile and 820px or less
export const isMobile = () => {
	return window.innerWidth <= 820
}
